import { Module } from 'vuex';
import { platformInfo, platformUpdate } from "@/request/api/platform"
import { localGet, localSet } from '@/config/storage'
import { menuList } from '@/request/api/role'
import { getMenu } from "@/request/api/auth"
import router from '@/router'

interface CounterState {
    platformInfo: object;
    loginInfo: object|string;
	token: string;
	account: string;
	avatar: string;
	menuList: object;
	isCollapse: boolean;
	pageSize: number|string|null;
	options: any;
}

const publicOptions: Module<CounterState, any> = {
    namespaced: true,
    state: {
        platformInfo: {},
        loginInfo: {},
		token: localGet('token') || '',
		account: localGet('account') || '',
		avatar: localGet('avatar') || '',
		menuList: [],
		isCollapse: false,
		pageSize: localGet('pageSize') || 10,
		options: [
			{label: '无', value: 0, type: 'none'},
			{label: '蓝牙BLE', value: 1, type: 'ble'},
			{label: '开关灯', value: 2, type: 'light'},
			{label: '播放', value: 3, type: 'play'},
			{label: '暂停', value: 4, type: 'pause'},
			{label: '上一曲', value: 5, type: 'prev'},
			{label: '下一曲', value: 6, type: 'next'},
			{label: '模式', value: 7, type: 'mode'},
			{label: '彩灯情景模式', value: 8, type: 'screen'},
			{label: '搜台', value: 9, type: 'fm'},
			{label: '延迟关灯', value: 10, type: 'time'},
			{label: 'EQ调节', value: 11, type: 'eq'},
			{label: '亮度调节', value: 12, type: 'light2'},
			{label: 'RGB调节', value: 13, type: 'color'},
			{label: '变更连接密码', value: 14, type: 'password'},
			{label: '经典蓝牙', value: 15, type: 'classicBluetooth'},
			{label: '人体感应', value: 16, type: 'sensing'},
			{label: '无线立体声', value: 17, type: 'liti'}, //value最高已经到18了，注意，18是双色灯情景模式，只是移到彩灯后面了
			{label: '双色灯情景模式', value: 18, type: 'screens'},
		],
    },
    mutations: {
		SAVE_PAGESIZE(state, value){
			state.pageSize = value
		},
		//保存平台信息
		SAVE_PLATFORMINFO(state, value){
			state.platformInfo = value
		},
		SAVE_ACCOUNT(state, value){
			state.account = value
		},
		SAVE_AVATAR(state, value){
			state.avatar = value
		},
		SAVE_TOKEN(state, value){
			state.token = value
		},
		SAVE_LOGININFO(state, value){
			state.loginInfo = value
		},
		SAVE_MENULLIST(state, value){
			state.menuList = value
		},
		MENU_COLLAPSE(state, value){
			state.isCollapse = value
		},
    },
    actions: {
		async getplatformInfo({commit}, paramas?:any) {
			try {
			  let {code, data} = await platformInfo()
			  if(code == 200){
				if(!data.webrtc) data.webrtc = '1'
				if(!data.openRegistration) data.openRegistration = '1'
				commit('SAVE_PLATFORMINFO', data)
			  }
			} catch (error) {
			  error && console.log(error)
			}
		},
		async getMenuList({commit}, paramas?:any){
			try {
				// const { code, data } = await menuList()
				const { code, data } = await getMenu()
				if(code == 200){
					commit('SAVE_MENULLIST', data)
					if(paramas == 1){
						for(let key in data){
							if(data[key].path){
								router.replace(data[key].path)
								return false
							}
						}
					}
				}			
			} catch (error) {
				console.log('menuList fail', error)
			}
		},
    },
    getters: {
		
    },
};

export default publicOptions;